<template>
  <Container>
    <div class="wizard__success">
      <v-layout align-center row wrap>
        <v-flex xs12 md6>
          <header class="wizard__success__header">
            <h1 class="wizard__success__title">{{ $t(`${namespace}.title`) }}</h1>
            <p class="wizard__success__text" v-html="$t(`${namespace}.text`)" />
          </header>

          <div class="wizard__success__content">
            <span class="wizard__success__list-title">{{ $t(`${namespace}.listTitle`) }}</span>
            <ul class="wizard__success__list">
              <li>
                <img src="./img/clock.svg" alt="">
                <span v-html="$t(`${namespace}.listItems`)[0]"></span>
              </li>
              <li>
                <img src="./img/money.svg" alt="">
                <span v-html="$t(`${namespace}.listItems`)[1]"></span>
              </li>
              <li>
                <img src="./img/chart.svg" alt="">
                <span v-html="$t(`${namespace}.listItems`)[2]"></span>
              </li>
            </ul>
          </div>
        </v-flex>

        <v-flex xs12 md6>
          <div class="wizard__success__image">
            <img src="./img/manager.svg" alt="">
          </div>
        </v-flex>
      </v-layout>

      <footer class="wizard__success__footer">
        <v-btn
          color="warning--gradient"
          class="mx-0"
          round
          depressed
          large
          @click="handleGoToPlatform"
        >
          <span v-html="$t(`${namespace}.buttonLabel`)" />
        </v-btn>
      </footer>
    </div>
  </Container>
</template>

<script>
import { mapActions } from 'vuex'
import Container from 'components/wizard/Container'

export default {
  name: 'Success',
  components: {
    Container
  },
  data () {
    return {
      namespace: 'Views.Wizard.success'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    handleSetStep () {
      this.$emit('handleSetStep', 'home')
    },

    handleGoToPlatform () {
      this.showAlert({
        type: 'success',
        message: this.$t(`${this.namespace}.message`)
      })

      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard__success {
  padding: 0 24px;

  @media (min-width: 992px) {
    padding: 0 40px;
  }
}

.wizard__success__title,
.wizard__success__text {
  font-family: 'Montserrat', sans-serif;
}

.wizard__success__title {
  color: $success;
  font-size: 24px;
  font-weight: 800;

  @media (min-width: 992px) {
    font-size: 36px;
  }
}

.wizard__success__text {
  font-size: 16px;
}

.wizard__success__content {
  font-size: 14px;
}

.wizard__success__list-title {
  display: block;
  margin-bottom: 28px;
  padding-top: 10px;
}

.wizard__success__list {
  list-style: none;
  padding: 0;

  @media (min-width: 992px) {
    padding-bottom: 36px;
  }

  li {
    margin-bottom: 36px;
    padding-left: 64px;
    position: relative;

    img {
      margin-right: 16px;
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &:nth-child(1) {

      img {
        width: 48px
      }
    }

    &:nth-child(2) {

      img {
        width: 46px
      }
    }

    &:nth-child(3) {
      img {
        width: 48px
      }
    }
  }
}

.wizard__success__image {

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto 30px;

    @media (min-width: 992px) {
      margin: 50px auto 0;
    }
  }
}

.wizard__success__footer {
  text-align: center;
}
</style>
